import { render, staticRenderFns } from "./CourseCalendar.vue?vue&type=template&id=199a56b7&scoped=true&"
import script from "./CourseCalendar.vue?vue&type=script&lang=js&"
export * from "./CourseCalendar.vue?vue&type=script&lang=js&"
import style0 from "./CourseCalendar.vue?vue&type=style&index=0&id=199a56b7&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "199a56b7",
  null
  
)

export default component.exports